/**
 * Formato de fechas de la pantalla de suscripción.
 *
 * Vive en su propio módulo porque lo usan el modal de baja y el bloque de la sección: cuando cada
 * uno resolvía la fecha por su cuenta, la MISMA pantalla mostraba `2026-10-15` en el modal y
 * `15/10/2026` dos centímetros más abajo.
 */

/**
 * `2026-09-01` → `1/9/2026`.
 *
 * Se parte el string a mano en vez de usar `new Date(iso)`: ese constructor interpreta un
 * `YYYY-MM-DD` pelado como MEDIANOCHE UTC, así que en Argentina (UTC-3) devuelve el día anterior.
 * Una fecha de corte de suscripción corrida un día es exactamente el tipo de error que nadie mira
 * dos veces.
 *
 * Devuelve `''` si no hay fecha, y el string original si no tiene la forma esperada — nunca
 * `Invalid Date`.
 *
 * ⚠️ El resultado lleva BARRAS, así que todo `t()` que lo interpole tiene que pasar
 * `interpolation: {escapeValue: false}`. `src/i18n.js` no desactiva el escapado, y el default de
 * i18next convierte el `/` en `&#x2F;`: como estas frases se insertan como TEXTO de React (que no
 * interpreta entidades), la pantalla muestra `2&#x2F;9&#x2F;2026` en crudo.
 */
export function formatSubscriptionDate(isoDate) {
    if (!isoDate) {
        return '';
    }
    const [year, month, day] = String(isoDate).slice(0, 10).split('-');
    if (!year || !month || !day) {
        return isoDate;
    }
    return `${Number(day)}/${Number(month)}/${year}`;
}
